import { useState, useEffect, useMemo } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Link,
} from "react-router-dom";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import MDTypography from "components/MDTypography";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";

import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";
import MegaMenu from "../../../adminPages/MegaMenu";
import { axios_get, axios_post } from "../../../axios";

import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
} from "examples/Navbars/DashboardNavbar/styles";

import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();

  const {
    miniSidenav,
    transparentNavbar,
    fixedNavbar,
    openConfigurator,
    darkMode,
    direction,
  } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [openFullScreenModal, setOpenFullScreenModal] = useState(false);
  const [usertype, setusertype] = useState(0);
  const navigate = useNavigate();
  const route = useLocation().pathname.split("/").slice(1);
  const [data, setData] = useState([]);
  const [compines, setCompines] = useState([]);
  const [locations, setlocations] = useState([]);

  const user_data = JSON.parse(localStorage.getItem("user_data"));

  const fetchcompanyList = async () => {
    const response = await axios_post(true, "company/user_matched_com_list", {
      company_id: user_data?.company_id,
    });

    if (response) {
      if (response.status) {
        setCompines(response.data); // This will be the single matching company
      } else {
        ToastMassage(response.message, "error");
      }
    }
  };

  const fetchlocationList = async (companyId) => {
    const response = await axios_post(true, "location/com_loc_list", {
      company_id: user_data?.company_id,
    });

    if (response && response.status) {
      const filteredLocations = response.data.filter(
        (location) => parseInt(location.compdesc) === parseInt(companyId)
      );

      setlocations(filteredLocations); // only show locations for selected company
    }
  };

  useEffect(() => {
    fetchcompanyList();
    fetchlocationList();

    if (fixedNavbar) setNavbarType("fixed");
    else setNavbarType("static");

    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    window.addEventListener("scroll", handleTransparentNavbar);
    handleTransparentNavbar();
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  const handle = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    });

    if (result.isConfirmed) {
      localStorage.clear();
      navigate("/auth/login");
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
    let tokenGet = localStorage.getItem("token");
    if (!tokenGet) return navigate("/auth/login");
    let usertype = localStorage.getItem("usertype");
    setusertype(usertype);
  }, [direction]);

  const handleClickMenu = () => {
    setOpenFullScreenModal(true);
  };

  const handleCloseFullScreenModal = () => {
    setOpenFullScreenModal(false);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const filteredRows = useMemo(() => {
    return data.filter((row) => {
      const itemCodeMatch = row.route;
      return itemCodeMatch?.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }, [searchTerm]);

  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");

  // 🚀 Add this custom event after updating localStorage in handleCompanyChange
  const handleCompanyChange = (event) => {
    const selectedComp = event.target.value;
    setSelectedCompany(selectedComp);

    const existingData = JSON.parse(localStorage.getItem("pos_filter") || "{}");

    const updatedData = {
      ...existingData,
      company_id: selectedComp,
    };

    localStorage.setItem("pos_filter", JSON.stringify(updatedData));

    // ✅ Dispatch custom event
    window.dispatchEvent(new Event("posFilterChanged"));

    fetchlocationList(selectedComp);
  };

  const handleLocationChange = (event) => {
    const selectedLocId = event.target.value;
    setSelectedLocation(selectedLocId);

    const existingData = JSON.parse(localStorage.getItem("pos_filter") || "{}");
    const updatedData = {
      ...existingData,
      location_id: selectedLocId,
    };
    localStorage.setItem("pos_filter", JSON.stringify(updatedData));

    // ✅ Dispatch custom event (optional if reloading)
    window.dispatchEvent(new Event("posFilterChanged"));

    // ✅ Force reload
    window.location.reload();
  };

  // below is for give alert message when we chnage company and location
  const handleCompanyChange1 = async (event) => {
    const selectedComp = event.target.value;

    // ✅ Show confirmation popup before applying change
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "All the saved data related to this company will be reset.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change company!",
    });

    if (!result.isConfirmed) return; // ❌ stop if user cancels

    setSelectedCompany(selectedComp);

    const existingData = JSON.parse(localStorage.getItem("pos_filter") || "{}");
    const updatedData = {
      ...existingData,
      company_id: selectedComp,
      location_id: null, // ✅ reset location when company changes
    };
    localStorage.setItem("pos_filter", JSON.stringify(updatedData));

    // ✅ Dispatch event for other components to react
    window.dispatchEvent(new Event("posFilterChanged"));

    fetchlocationList(selectedComp);
  };

  const handleLocationChange1 = async (event) => {
    const selectedLocId = event.target.value;

    // ✅ Show confirmation popup before applying change
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "All the saved data related to this location will be reset.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change location!",
    });

    if (!result.isConfirmed) return; // ❌ stop if user cancels

    setSelectedLocation(selectedLocId);

    const existingData = JSON.parse(localStorage.getItem("pos_filter") || "{}");
    const updatedData = {
      ...existingData,
      location_id: selectedLocId,
    };
    localStorage.setItem("pos_filter", JSON.stringify(updatedData));

    // ✅ Dispatch event for other components to react
    window.dispatchEvent(new Event("posFilterChanged"));

    // reload if needed
    window.location.reload();
  };

  useEffect(() => {
    const savedFilter = JSON.parse(localStorage.getItem("pos_filter"));
    if (savedFilter) {
      if (savedFilter.company_id) {
        setSelectedCompany(savedFilter.company_id);
        fetchlocationList(savedFilter.company_id); // load relevant locations
      }

      if (savedFilter.location_id) {
        setSelectedLocation(savedFilter.location_id);
      }
    }
  }, [compines.length]); // run after companies are loaded

  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <MDBox px={2} py={1}>
        <FormControl fullWidth size="small" style={{ marginTop: 2 }}>
          <InputLabel>Select Company</InputLabel>
          <Select
            value={selectedCompany}
            label="Select Company"
            onChange={handleCompanyChange}
          >
            {compines.map((comp) => (
              <MenuItem key={comp.id} value={comp.id}>
                {comp.compdesc}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Divider sx={{ my: 1 }} />

        <FormControl fullWidth size="small" style={{ marginTop: 4 }}>
          <InputLabel>Select Location</InputLabel>
          <Select
            value={selectedLocation}
            label="Select Location"
            onChange={handleLocationChange}
          >
            {locations.map((loc) => (
              <MenuItem key={loc.id} value={loc.id}>
                {loc.locname}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Divider sx={{ my: 1 }} />
      </MDBox>

      <Link to="/change-password" style={{ textDecoration: "none" }}>
        <NotificationItem
          icon={<Icon>password</Icon>}
          title="Password Change"
        />
      </Link>
    </Menu>
  );

  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;
      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }
      return colorValue;
    },
  });

  const [empId, setEmpId] = useState(null);

  useEffect(() => {
    const role_id = Number(localStorage.getItem("role_id"));
    if (role_id) {
      console.log("Employee ID from localStorage:", role_id);

      setEmpId(role_id);
    }
  }, []);

  return (
    <AppBar position="sticky" color="inherit">
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini })}
        >
          <IconButton
            size="small"
            disableRipple
            color="inherit"
            onClick={handleMiniSidenav}
          >
            <Icon sx={iconsStyle} fontSize="medium">
              {miniSidenav ? "menu_open" : "menu"}
            </Icon>
          </IconButton>

          {empId === 1 && (
            <Button size="small" color="inherit" onClick={handleClickMenu}>
              Menu
            </Button>
          )}
          {/* {empId != 2 ||
            (empId != 5 && (
              <Button size="small" color="inherit" onClick={handleClickMenu}>
                Menu
              </Button>
            ))} */}
        </MDBox>

        {!isMini && (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox color={light ? "white" : "inherit"}>
              {user_data && (
                <>
                  <IconButton sx={navbarIconButton} size="small" disableRipple>
                    {user_data.firstname} {user_data.lastname}
                  </IconButton>
                </>
              )}

              <IconButton
                sx={navbarIconButton}
                size="small"
                disableRipple
                onClick={handle}
              >
                <Icon sx={iconsStyle}>logout</Icon>
              </IconButton>

              <IconButton
                sx={navbarIconButton}
                onClick={handleOpenMenu}
                size="small"
                disableRipple
              >
                <Icon sx={iconsStyle}>account_circle</Icon>
              </IconButton>
              {renderMenu()}

              <Dialog
                style={{ padding: "50px 50px" }}
                fullScreen
                open={openFullScreenModal}
                onClose={handleCloseFullScreenModal}
              >
                <MegaMenu />
                <DialogActions>
                  <MDButton
                    onClick={handleCloseFullScreenModal}
                    variant="gradient"
                    color="secondary"
                  >
                    Close
                  </MDButton>
                </DialogActions>
              </Dialog>
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
